import { render, staticRenderFns } from "./serveInfo.vue?vue&type=template&id=fc13fd84&scoped=true&"
import script from "./serveInfo.vue?vue&type=script&lang=js&"
export * from "./serveInfo.vue?vue&type=script&lang=js&"
import style0 from "./serveInfo.vue?vue&type=style&index=0&id=fc13fd84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc13fd84",
  null
  
)

export default component.exports